export { default } from './compareTable'